import { styled } from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "CategoryMenustyle__Container",
  componentId: "sc-zro0tb-0"
})(["", " a{", "}span{", "}@media (max-width:", "){", " .ant-skeleton-input{", "}}"], {
  "display": "flex",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "marginRight": "0.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 191 60 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginLeft": "0.75rem",
  "marginRight": "0.75rem"
}, {
  "width": "75% !important"
});